<template>
    <div class="warranty-page">
        <div class="header">
            <van-nav-bar :title="$t('warranty_application')" left-arrow @click-left="goBack" />
        </div>

        <div class="warranty-content">
            <div class="product-info">
                <h3>{{ $t('product_info') }}</h3>
                <div class="info-item">
                    <span class="label">{{ $t('product_name') }}：</span>
                    <span class="value">{{ productName || 'N/A' }}</span>
                </div>
                <div class="info-item">
                    <span class="label">{{ $t('traning_code') }}：</span>
                    <span class="value">{{ traceNo }}-{{ num }}</span>
                </div>
                <div class="info-item">
                    <span class="label">{{ $t('batch_no') }}：</span>
                    <span class="value">{{ batchNo || 'N/A' }}</span>
                </div>
                <div class="info-item warranty-status">
                    <span class="label">{{ $t('warranty_status') }}：</span>
                    <span class="value" :class="{ 'expired': isExpired }">
                        {{ isExpired ? $t('warranty_expired') : $t('warranty_valid') }}({{ $t('start_time') }}:{{
                        startTime || 'N/A' }})
                    </span>
                </div>
            </div>

            <div class="application-form" v-if="subAble && !isExpired">
                <h3>{{ $t('application_info') }}</h3>
                <van-form @submit="onSubmit">
                    <van-cell-group inset>
                        <van-field v-model="applicant.name" :label="$t('applicant_name')"
                            :placeholder="$t('please_input_name')"
                            :rules="[{ required: true, message: $t('name_required') }]" />
                        <van-field v-model="applicant.contact" :label="$t('contact_info')"
                            :placeholder="$t('please_input_contact')"
                            :rules="[{ required: true, message: $t('contact_required') }]" />
                        <van-field v-model="feedbackContent" :label="$t('feedback_content')" type="textarea"
                            :placeholder="$t('please_input_feedback')" rows="3" autosize
                            :rules="[{ required: true, message: $t('feedback_required') }]" />
                        <van-field v-model="applicant.ask" :label="$t('feed_ask')" type="textarea" />
                    </van-cell-group>

                    <div style="margin: 16px;">
                        <van-button round block type="primary" native-type="submit">
                            {{ $t('submit_application') }}
                        </van-button>
                    </div>
                </van-form>
            </div>
            <div class="warranty-form" v-show="!subAble">
                <van-notice-bar color="#fd9322" background="#ecf9ff" left-icon="info-o" text="">{{ $t('warranty_tips')
                    }}</van-notice-bar>
            </div>


            <!-- 历史记录入口 -->
            <div class="history-entry" @click="showHistory">
                <van-cell is-link :title="$t('history_records')" />
            </div>
            
        </div>

        <!-- 历史记录弹窗 -->
        <van-popup v-model="showHistoryPopup" position="bottom" :style="{ height: '80%' }" round>
            <div class="history-popup">
                <div class="popup-header">
                    <span>{{ $t('history_records') }}</span>
                    <van-icon name="close" @click="showHistoryPopup = false" />
                </div>
                <div class="popup-content">
                    <van-list finished-text="没有更多了">
                        <div v-if="historyList.length === 0" class="no-data">
                            {{ $t('no_history_records') }}
                        </div>
                        <van-cell v-for="(item, index) in historyList" :key="index" class="history-item">
                            <div class="history-content">
                                <div class="history-header">
                                    <span class="date">{{ formatTimestamp(item.created) }}</span>
                                    <van-tag :type="getStatusType(item.status)">{{ getStatusText(item.status)
                                        }}</van-tag>
                                </div>
                                <div class="content">{{$t('application_info')}}：{{ item.description }}</div>
                                <div class="content">{{$t('feed_ask')}}：{{ item.ask }}</div>
                                <div class="result" v-if="item.feedback">
                                    <div class="result-title">{{ $t('processing_result') }}：</div>
                                    <div class="result-content">{{ item.feedback }}</div>
                                </div>
                                <div class="reason" v-if="item.reason">
                                    <div class="reason-title">{{ $t('reason') }}：</div>
                                    <div class="reason-content">{{ item.reason }}</div>
                                </div>
                            </div>
                        </van-cell>
                    </van-list>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant';
import axios from 'axios';
export default {
    name: "Warranty",
    data() {
        return {
            traceNo: '',
            num: '',
            checkCode: '',
            productName: '',
            batchNo: '',
            isExpired: false,
            startTime: '',
            applicant: {
                name: '',
                contact: '',
                ask: ''
            },
            subAble: false,
            feedbackContent: '',
            hasProgress: false,
            activeProgress: 0,

            // 历史记录相关
            showHistoryPopup: false,
            historyList: [],

       
        };
    },
    mounted() {
        // 从路由参数中获取产品信息
        const pathParts = this.$route.path.split('/');
        if (pathParts.length >= 4) {
            this.traceNo = pathParts[pathParts.length - 3];
            this.num = pathParts[pathParts.length - 2];
            this.checkCode = pathParts[pathParts.length - 1];
        }

        // 获取产品信息
        this.loadProductInfo();
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        formatTimestamp(timestamp) {
            if (!timestamp) return 'N/A';

            // 如果是秒级时间戳，转换为毫秒级
            if (timestamp.toString().length === 10) {
                timestamp = timestamp * 1000;
            }

            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        loadProductInfo() {
            const params = {
                trace_no: this.traceNo,
                num: this.num,
                code: this.checkCode,


            };
            console.log(this.traceNo, this.num, this.checkCode);
            axios({
                method: "GET",
                url: "/feedback/get",
                headers: {
                    "Content-Type": "application/json",
                },
                params: params
            }).then((res) => {
                if (res.data.code === 200) {
                    this.isExpired = res.data.data.is_expire;
                    this.productName = res.data.data.product_name;
                    this.batchNo = res.data.data.batch_no;
                    this.startTime = res.data.data.start;
                    this.historyList = res.data.data.feedback ? res.data.data.feedback : [];
                    // 迭代feedback
                    this.subAble = true;
                    this.historyList.forEach(item => {
                        if (item.status === 'SUB' || item.status === 'ACCEPT') {
                            this.subAble = false
                        }
                    });
                } else {
                    Toast.fail(res.data.msg);
                }
            }).catch((error) => {
                console.error('获取产品信息失败:', error);
                Toast.fail(this.$t('load_data_failed'));
            });
        },
        onSubmit() {
            // 提交保修申请逻辑
            const params = {
                trace_no: this.traceNo,
                num: parseInt(this.num),
                code: parseInt(this.checkCode),
                content: this.feedbackContent,
                mobile: this.applicant.contact,
                name: this.applicant.name,
                ask:this.applicant.ask
            };
            axios({
                method: "POST",
                url: "/feedback/sub",
                headers: {
                    "Content-Type": "application/json",
                },
                data: params
            }).then((res) => {
                if (res.data.code === 200) {
                    Toast.success(this.$t('application_submitted_success'));
                } else {
                    Toast.fail(res.data.message);
                }
            }).catch((error) => {
                console.error('获取产品信息失败:', error);
                Toast.fail(this.$t('load_data_failed'));
            });
            // 这里应该调用API提交申请
            console.log('提交保修申请:', {
                traceNo: this.traceNo,
                num: this.num,
                applicant: this.applicant,
                feedback: this.feedbackContent
            });
        },

        // 显示历史记录
        showHistory() {
            this.showHistoryPopup = true;
        },
        // 获取状态文本
        getStatusText(status) {
            switch (status) {
                case 'SUB':
                    return this.$t('status_submitted');
                case 'ACCEPT':
                    return this.$t('status_processing');
                case 'SOLVED':
                    return this.$t('status_processed');
                case 'FAIL':
                    return this.$t('status_failed');
                default:
                    return this.$t('status_unknown');
            }
        },

        // 获取状态标签类型
        getStatusType(status) {
            switch (status) {
                case 'submitted':
                    return 'primary';
                case 'processing':
                    return 'warning';
                case 'processed':
                    return 'success';
                default:
                    return 'default';
            }
        }
    }
};
</script>

<style lang="less" scoped>
.warranty-page {
    max-width: 660px;
    margin: 0 auto;
    background-color: #f5f5f5;
    min-height: 100vh;

    .header {
        position: sticky;
        top: 0;
        z-index: 100;
    }

    .warranty-content {
        padding: 15px;

        .product-info,
        .application-form,
        .history-entry,
        .progress-info {
            background: white;
            border-radius: 8px;
            padding: 15px;
            margin-top: 10px;
            margin-bottom: 15px;

            h3 {
                margin-top: 0;
                margin-bottom: 15px;
                font-size: 18px;
                color: #333;
                border-left: 4px solid #1989fa;
                padding-left: 10px;
            }

            .info-item {
                display: flex;
                margin-bottom: 10px;
                font-size: 14px;

                .label {
                    color: #666;
                    width: 100px;
                }

                .value {
                    flex: 1;
                    color: #333;

                    &.expired {
                        color: #ee0a24;
                    }
                }
            }
        }

        .history-entry {
            padding: 0;

            :deep(.van-cell) {
                background: transparent;
            }
        }

        .progress-info {
            .time {
                font-size: 12px;
                color: #999;
            }
        }
    }
}

// 历史记录弹窗样式
.history-popup {
    height: 100%;
    display: flex;
    flex-direction: column;

    .popup-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        font-size: 16px;
        font-weight: 500;
        border-bottom: 1px solid #f0f0f0;

        .van-icon {
            font-size: 20px;
            color: #999;
        }
    }

    .popup-content {
        flex: 1;
        overflow-y: auto;
        padding: 10px 0;

        .no-data {
            text-align: center;
            padding: 30px;
            color: #999;
        }

        .history-item {
            :deep(.van-cell__value) {
                flex: none;
            }
        }

        .history-content {
            width: 100%;

            .history-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 8px;

                .date {
                    font-size: 14px;
                    color: #666;
                }
            }

            .content {
                font-size: 15px;
                color: #333;
                margin-bottom: 10px;
                line-height: 1.5;
            }

            .result,
            .reason {
                font-size: 13px;
                margin-bottom: 5px;

                .result-title,
                .reason-title {
                    color: #666;
                    display: inline;
                }

                .result-content,
                .reason-content {
                    color: #333;
                    display: inline;
                }
            }
        }
    }
}
</style>